import { TesselatedFontTable } from '../text/TesselatedFontTable';
import { Font } from '../text/Font';
import { AssetBase } from '@awayjs/core';
import { FontStyleName } from '../text/FontStyleName';
var DefaultFontManager = /** @class */ (function () {
    function DefaultFontManager() {
    }
    DefaultFontManager.getDefaultFont = function () {
        if (!this._default_font) {
            this.setDefaultFont();
        }
        return this._default_font;
    };
    DefaultFontManager.applySharedFonts = function (ns) {
        if (ns === this.shared_fonts_ns) {
            return;
        }
        if (!this._registered_fonts[ns]) {
            this._registered_fonts[ns] = {};
        }
        if (!this._registered_fonts[this.shared_fonts_ns]) {
            this._registered_fonts[this.shared_fonts_ns] = {};
        }
        if (!this._default_font) {
            if (this._registered_fonts[this.shared_fonts_ns]['arial']) {
                this._default_font = this._registered_fonts[this.shared_fonts_ns]['arial'];
            }
        }
        var fontsInSharedSWF = this._registered_fonts[this.shared_fonts_ns];
        for (var key in fontsInSharedSWF) {
            if (!this._registered_fonts[ns][key]) {
                this._registered_fonts[ns][key] = fontsInSharedSWF[key];
            }
            else {
                var len = this._registered_fonts[this.shared_fonts_ns][key].font_styles.length;
                for (var i = 0; i < len; i++) {
                    var fontStyle = this._registered_fonts[this.shared_fonts_ns][key].font_styles[i];
                    var oldTable = this._registered_fonts[ns][key].get_font_table(fontStyle.name, TesselatedFontTable.assetType, null, false);
                    if (!oldTable) {
                        this._registered_fonts[ns][key].font_styles.push(fontStyle);
                    }
                    else if (!oldTable.getGlyphCount()) {
                        this._registered_fonts[ns][key].replace_font_table(fontStyle.name, fontStyle);
                    }
                }
            }
            if (this._registered_fonts[ns][key].font) {
                this._registered_fonts[ns][key] = fontsInSharedSWF[key];
            }
        }
    };
    DefaultFontManager.defineFont = function (fontName, ns) {
        if (ns === void 0) { ns = AssetBase.DEFAULT_NAMESPACE; }
        this._registered_fonts || (this._registered_fonts = {});
        this._registered_fonts[ns] || (this._registered_fonts[ns] = {});
        //console.warn("defineFont", fontName, ns);
        // stop grouping by fontName - needed for SF
        //fontName = (fontName + '').toLowerCase().replace(/bold|italic|regular/g, '').trim();
        //const alias = fontName.replace(/ |-/g, '');
        var font = this._registered_fonts[ns][fontName]; //|| this._registered_fonts[ns][alias];
        if (font) {
            return font;
        }
        if (this._namespaces.indexOf(ns) === -1) {
            this._namespaces.push(ns);
        }
        font = new Font();
        font.name = fontName;
        if (!this._default_font) {
            //this.deviceFont = this._default_font = font;
        }
        this._registered_fonts[ns][fontName] = font;
        // stop grouping by fontName - needed for SF
        //this._registered_fonts[ns][alias] = font;
        return font;
    };
    DefaultFontManager.registerFontForClassName = function (font, className) {
        this._registered_fonts_by_className[className] = font;
    };
    DefaultFontManager.getFont = function (fontName, namespace) {
        if (namespace === void 0) { namespace = undefined; }
        //console.warn("get font", fontName, DefaultFontManager._registered_fonts);
        if (!fontName) {
            return this.getDefaultFont();
        }
        // hack for dynamic fonts: first check if reguested font-name is a classname that was registered
        if (this._registered_fonts_by_className[fontName]) {
            return this._registered_fonts_by_className[fontName];
        }
        var ns = namespace || AssetBase.DEFAULT_NAMESPACE;
        // stop grouping by fontName - needed for SF
        //fontName = (fontName + '').toLowerCase().replace(/bold|italic|regular|-/g, '').trim();
        this._registered_fonts || (this._registered_fonts = {});
        this._registered_fonts[ns] || (this._registered_fonts[ns] = {});
        var font = this._registered_fonts[ns][fontName];
        if (font) {
            return font;
        }
        else if (this._namespaces.length > 0 && !namespace) {
            // lookup over all NS
            for (var _i = 0, _a = this._namespaces; _i < _a.length; _i++) {
                var ns_1 = _a[_i];
                if (this._registered_fonts[ns_1][fontName]) {
                    return this._registered_fonts[ns_1][fontName];
                }
            }
        }
        //console.log("no font found for");
        return this.getDefaultFont();
    };
    DefaultFontManager.getFontTable = function (fontName, namespace) {
        if (namespace === void 0) { namespace = undefined; }
        if (!fontName) {
            return this.getDefaultFont().get_font_table(FontStyleName.STANDART);
        }
    };
    DefaultFontManager.setDefaultFont = function (font) {
        if (font === void 0) { font = null; }
        this.deviceFont = this._default_font = (font || new Font());
        /*
        var allchars=[];
        //allchars[cnt1++] = ['33',[0,0,226,67,0,192,11,68,127,127,0,0,0,128,177,67,0,80,137,68,127,127,0,0,0,0,212,67,0,192,204,68,127,127,0,0,0,0,212,67,0,192,204,68,127,127,0,0,0,128,177,67,0,80,137,68,127,127,0,0,0,0,129,67,0,192,204,68,127,127,0,0,0,0,129,67,0,192,204,68,127,127,0,0,0,128,177,67,0,80,137,68,127,127,0,0,0,0,100,67,0,192,11,68,127,127,0,0,0,0,100,67,0,192,11,68,127,127,0,0,0,128,177,67,0,80,137,68,127,127,0,0,0,0,226,67,0,192,11,68,127,127,0,0,0,0,221,67,0,0,0,69,127,127,0,0,0,0,170,67,0,208,242,68,127,127,0,0,0,0,110,67,0,0,0,69,127,127,0,0,0,0,110,67,0,0,0,69,127,127,0,0,0,0,170,67,0,208,242,68,127,127,0,0,0,0,110,67,0,160,229,68,127,127,0,0,0,0,110,67,0,160,229,68,127,127,0,0,0,0,170,67,0,208,242,68,127,127,0,0,0,0,221,67,0,160,229,68,127,127,0,0,0,0,221,67,0,160,229,68,127,127,0,0,0,0,170,67,0,208,242,68,127,127,0,0,0,0,221,67,0,0,0,69,127,127]]
        var i:number=0;
        for(i=0; i<cnt1;i++){
            var vertexBuffer:AttributesBuffer = new AttributesBuffer(20, allchars[i][1].length / 20);
            vertexBuffer.bufferView = new Uint8Array(<ArrayBuffer> allchars[i][1]);

            var curve_elements:TriangleElements = new TriangleElements(vertexBuffer);

            curve_elements.setPositions(new Float2Attributes(vertexBuffer));
            curve_elements.setCustomAttributes("curves", new Float3Attributes(vertexBuffer));

            //add UVs if they exist in the data
            if (attr_count == 28)
                curve_elements.setUVs(new Float2Attributes(vertexBuffer));

            new_font_style.setChar(font_style_char.toString(), curve_elements, char_width);
            DefaultFontManager._default_font_table = new TesselatedFontTable();
        }
        */
        //DefaultFontManager._default_font_table.
    };
    DefaultFontManager.clearAll = function () {
        this._default_font = null;
        this._registered_fonts = {};
        this.shared_fonts_ns = null;
    };
    DefaultFontManager._registered_fonts = {};
    DefaultFontManager._registered_fonts_by_className = {};
    DefaultFontManager._namespaces = [];
    DefaultFontManager.deviceFont = null;
    return DefaultFontManager;
}());
export { DefaultFontManager };
